/**
 * Allows you to add data-method="METHOD to links to automatically inject a form
 * with the method on click
 *
 * Example: <a href="{{route('customers.destroy', $customer->id)}}"
 * data-method="delete" name="delete_item">Delete</a>
 *
 * Injects a form with that's fired on click of the link with a DELETE request.
 * Good because you don't have to dirty your HTML with delete forms everywhere.
 */

 var Dropzone = require('dropzone');
 // import intl tel input
 import intlTelInput from 'intl-tel-input';

function addDeleteForms() {
    $('[data-method]').append(function () {
        if (!$(this).find('form').length > 0) {
            return "\n<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
                "<input type='hidden' name='_method' value='" + $(this).attr('data-method') + "'>\n" +
                "<input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                '</form>\n';
        } else { return '' }
    })
    .attr('href', '#')
    .attr('style', 'cursor:pointer;')
    .attr('onclick', '$(this).find("form").submit();');
}

/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Add the data-method="delete" forms to all delete links
     */
    addDeleteForms();

    // Remove transparent class from navbar when scrolled
    $(window).scroll(function() {
        if ($(document).scrollTop() > 100) {
            $('.frontend').removeClass('transparent');
        } else {
            $('.frontend').addClass('transparent');
        }
    });

    setTimeout(function() {
        $('.alert-disappear').fadeOut(3000);
    }, 5000);

    $('a[data-confirm]').on('click', function() {
        var id = $(this).attr('data-confirm');
        var text = $(this).text();
        var item = $(this);
        var endpoint = window.location.origin + '/dashboard/users/status/' + id;

        $.ajax({
            type: "POST",
            url: endpoint,
            data: { _token: $('meta[name="csrf-token"]').attr('content') },
            dataType: "json",
            success: function (response) {
                console.log(response, 'response')
                if(response.success) {
                    text = response.data === 1 ? 'Yes' : 'No';
                    response.data === 1 ? item.removeClass('bg-secondary').addClass('bg-info') : item.removeClass('bg-info').addClass('bg-secondary');
                    item.text(text);
                }
            }
        });
        
    });

    // Make record active or inactive
    $('a[data-active]').on('click', function() {
        var id = $(this).attr('data-active');
        var text = $(this).text();
        var item = $(this);
        var endpoint = window.location.origin + '/dashboard/business/active/' + id;

        $.ajax({
            type: "POST",
            url: endpoint,
            data: { _token: $('meta[name="csrf-token"]').attr('content') },
            dataType: "json",
            success: function (response) {
                console.log(response, 'response')
                if(response.success) {
                    text = response.data === 1 ? 'Active' : 'Inactive';
                    response.data === 1 ? item.removeClass('bg-secondary').addClass('bg-success') : item.removeClass('bg-success').addClass('bg-secondary');
                    item.text(text);
                }
            }
        });
        
    });

    // Make record verify or unverify
    $('a[data-verify]').on('click', function() {
        var id = $(this).attr('data-verify');
        var text = $(this).text();
        var item = $(this);
        var endpoint = window.location.origin + '/dashboard/business/verify/' + id;

        $.ajax({
            type: "POST",
            url: endpoint,
            data: { _token: $('meta[name="csrf-token"]').attr('content') },
            dataType: "json",
            success: function (response) {
                console.log(response, 'response')
                if(response.success) {
                    text = response.data === 1 ? 'Verified' : 'Unverified';
                    response.data === 1 ? item.removeClass('bg-secondary').addClass('bg-info') : item.removeClass('bg-info').addClass('bg-secondary');
                    item.text(text);
                }
            }
        });

    });

    // Validation number 2
    $(".validate2").validate({
        submitHandler: function(form) {
            // maybe disabling submit button
            $('.validate2 button').prop('disabled', true);
            var btnText = $('.validate2 button[type=submit]').text();
            $('.validate2 button[type=submit]').text('Submitting...');
            var formData = $(form).serialize();
            console.log(formData,'fromdata');

            $.ajax({
                type: "POST",
                url: $(form).attr('action'),
                data: formData,
                dataType: "json",
                success: (data) => {
                    if(data.success) {
                        $('.validate2 button[type=submit]').html('Completing...');
                        $('.validate2 .alert').removeClass('d-none').removeClass('alert-danger').addClass('alert-success');
                        $('.validate2 .alert span').text(data.message);    
                        if(data.redirect) {
                            setTimeout(() => {
                                window.location = data.redirect;
                            }, 2000);
                        }else {
                            setTimeout(() => {
                                window.location.reload();
                            }, 2000);
                        }
                    }
                },
                error: (data) => {
                    console.log(data);
                    $('.validate2 button').prop('disabled', false);
                    $('.validate2 button[type=submit]').text(btnText);
                    $('.validate2 .alert').removeClass('d-none');
                    $('.validate2 .alert span').text(data.responseJSON.message);
                }
            });
        }    
            
    });

    $(".validate").validate({
        submitHandler: function(form) {
            // maybe disabling submit button
            $('.validate button').prop('disabled', true);
            var btnText = $('.validate button[type=submit]').text();
            $('.validate button[type=submit]').text('Submitting...');

            // Check if reCAPTCHA is loaded and form needs it
            if (typeof grecaptcha !== 'undefined' && typeof window.recaptchaSiteKey !== 'undefined' && $(form).find('[name="g-recaptcha-response"]').length === 0) {
                console.log('reCAPTCHA detected, generating token...');
                console.log('Site Key:', window.recaptchaSiteKey);
                grecaptcha.ready(function() {
                    grecaptcha.execute(window.recaptchaSiteKey, {action: 'submit'}).then(function(token) {
                        console.log('reCAPTCHA token generated:', token.substring(0, 50) + '...');
                        // Add reCAPTCHA token to form
                        $('<input>').attr({
                            type: 'hidden',
                            name: 'g-recaptcha-response',
                            value: token
                        }).appendTo(form);

                        // Now submit the form via AJAX
                        submitFormAjax(form, btnText);
                    }).catch(function(error) {
                        console.error('reCAPTCHA error:', error);
                        $('.validate button').prop('disabled', false);
                        $('.validate button[type=submit]').text(btnText);
                        alert('reCAPTCHA failed to load. Please refresh the page and try again.');
                    });
                });
            } else {
                console.log('reCAPTCHA check:', {
                    'grecaptcha defined': typeof grecaptcha !== 'undefined',
                    'siteKey defined': typeof window.recaptchaSiteKey !== 'undefined',
                    'existing token': $(form).find('[name="g-recaptcha-response"]').length
                });
                // No reCAPTCHA needed or token already exists, submit directly
                submitFormAjax(form, btnText);
            }

            function submitFormAjax(form, btnText) {
                var formData = $(form).serialize();
                console.log(formData,'fromdata');

                $.ajax({
                    type: "POST",
                    url: $(form).attr('action'),
                    data: formData,
                    dataType: "json",
                    success: (data) => {
                        console.log('SUCCESS RESPONSE:', data);
                        if(data.success) {
                            $('.validate button[type=submit]').html('Completing...');
                            $('.validate .alert').removeClass('d-none').removeClass('alert-danger').addClass('alert-success');
                            $('.validate .alert span').text(data.message);

                            if(data.redirect) {
                                setTimeout(() => {
                                    window.location = data.redirect;
                                }, 2000);
                            }else {
                                setTimeout(() => {
                                    window.location.reload();
                                }, 2000);
                            }
                        }
                    },
                    error: (data) => {
                        console.log('ERROR RESPONSE:', data);
                        console.log('ERROR MESSAGE:', data.responseJSON);
                        $('.validate button').prop('disabled', false);
                        $('.validate button[type=submit]').text(btnText);
                        $('.validate .alert').removeClass('d-none').addClass('alert-danger');

                        // Show validation errors if they exist
                        if(data.responseJSON && data.responseJSON.message) {
                            $('.validate .alert span').text(data.responseJSON.message);
                        }
                        if(data.responseJSON && data.responseJSON.errors) {
                            console.log('VALIDATION ERRORS:', data.responseJSON.errors);
                        }

                        // Remove the token so a new one is generated on next submit
                        $(form).find('[name="g-recaptcha-response"]').remove();
                    }
                });
            }
        }
    });


    $("#validate_video_add").validate({
        submitHandler: function(form) {
            // maybe disabling submit button
            $('#validate_video_addbutton').prop('disabled', true);
            var btnText = $('.validate button[type=submit]').text();
            $('#validate_video_add button[type=submit]').text('Submitting...');
            var formData = $(form).serialize();
            console.log(formData,'fromdata');

            $.ajax({
                type: "POST",
                url: $(form).attr('action'),
                data: formData,
                dataType: "json",
                complete: (data) => {
                    $('#validate_video_add button').prop('disabled', false);
                    $('#validate_video_add button[type=submit]').text(btnText);
                },
                error: (data) => {
                    console.log(data);
                    $('.validate button').prop('disabled', false);
                    $('.validate button[type=submit]').text(btnText);
                    $('.validate .alert').removeClass('d-none');
                    $('.validate .alert span').text(data.responseJSON.message);
                }
            });
        }
    });

    $("#update_business").validate({
        submitHandler: function(form) {
            // maybe disabling submit button
            $('.validate button').prop('disabled', true);
            var btnText = $('.validate button[type=submit]').text();
            $('.validate button[type=submit]').text('Submitting...');
            var formData = $(form).serialize();

            $.ajax({
                type: "POST",
                url: $(form).attr('action'),
                data: formData,
                dataType: "json",
                success: (data) => {
                    if(data.success) {
                        $('.validate button[type=submit]').text('Completing...');
                        $('.validate .alert').removeClass('d-none').removeClass('alert-danger').addClass('alert-success');
                        $('.validate .alert span').text(data.message);
                        setTimeout(() => {
                            window.location = data.redirect;
                        }, 2000);
                    }
                },
                error: (data) => {
                    console.log(data);
                    $('.validate button').prop('disabled', false);
                    $('.validate button[type=submit]').text(btnText);
                    $('.validate .alert').removeClass('d-none');
                    $('.validate .alert span').text(data.responseJSON.message);
                }
            });
        }
    });

    $(".delete").validate({
        submitHandler: function(form) {
            // maybe disabling submit button
            $('.delete button').prop('disabled', true);
            var btnText = $('.delete button[type=submit]').text();
            $('.delete button[type=submit]').text('Submitting...');
            var formData = $(form).serialize();

            $.ajax({
                type: "POST",
                url: $(form).attr('action'),
                data: formData,
                dataType: "json",
                success: (data) => {
                    if(data.success) {
                        $('.delete button[type=submit]').html('Completing...');
                        $('.delete .alert').removeClass('d-none').removeClass('alert-danger').addClass('alert-success');
                        $('.delete .alert span').text(data.message);    
                        if(data.redirect) {
                            setTimeout(() => {
                                window.location = data.redirect;
                            }, 1000);
                        }else {
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        }
                    }
                },
                error: (data) => {
                    console.log(data);
                    $('.delete button').prop('disabled', false);
                    $('.delete button[type=submit]').text(btnText);
                    $('.delete .alert').removeClass('d-none');
                    $('.delete .alert span').text(data.responseJSON.message);
                }
            });
        }
    });

    // Add scrollbar to .scrollbar div
    $('.scrollbar').niceScroll({
        cursorcolor: '#999999', // Changing the scrollbar color
        cursorwidth: 4, // Changing the scrollbar width
        cursorborder: 'none', // Rempving the scrollbar border
    });

    // Get video link on page and embed it properly
    if($('#embed').html()){
        var src = $(iframe).attr('src');
        var html = `<div class="video-responsive">
                        <iframe width="420" height="315" src="${src}" frameborder="0" allowfullscreen></iframe>
                    </div>`;
        $('#embed').html(html);
        $(iframe).parent().hide();
    }

    // File Upload Preview Plugin
    $('.fileuploader button[type=submit]').addClass('disabled');

    var readURL = function(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                $('.profile-pic').attr('src', e.target.result);
            }

            reader.readAsDataURL(input.files[0]);
        }
    }

    $(".file-upload").on('change', function(){
        readURL(this);
        console.log(this.files[0])
        $('.fileuploader button[type=submit]').removeClass('disabled');
    });

    $(".upload-button").on('click', function() {
    $(".file-upload").click();
    });

    $('.fileuploader button[type=submit]').on('click', function() {
        $('.fileuploader button[type=submit]').addClass('disabled');
        $('.fileuploader button[type=submit]').text('Uploading...');
    });

    $(".regular").submit(function () {
        $('.regular button[type=submit]').addClass('disabled');
        $('.regular button[type=submit]').text('Processing...');
    });

    const input = document.querySelector("#phone");

    // if input exists on the page
    if (input) {
        const iti = intlTelInput(input, {
            loadUtilsOnInit: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js",
            initialCountry: "lr",
            separateDialCode: true,
            hiddenInput: function(telInputName) {
                return {
                    phone: "phone_full",
                    country: "country_code"
                };
            },
        });
        if (iti && iti.promise && typeof iti.promise.catch === "function") {
            iti.promise.catch(function() {});
        }
    }

});

// Slick carousel initialization moved to individual view files to prevent loading issues